module.exports = __webpack_public_path__ + "static/media/close_orange.d1af087e.svg";